module.exports = __webpack_public_path__ + "static/media/photo_mobile.76399ea1.png";